import request from '@/utils/request';

let jingdongApi = {
  // 推广信息设置
  saveJdSetting(data, err) {
    return request._postBody('/shop/setting/jdSetting/saveJdSetting', data, err);
  },

  // 获取推广信息
  getJdSetting(data, err) {
    return request._get('/shop/setting/jdSetting/getJdSetting', data, err);
  },
  // 佣金配置设置
  saveJdCommissionSetting(data, err) {
    return request._postBody('/shop/setting/jdSetting/saveJdCommissionSetting', data, err);
  },

  // 获取佣金配置
  getJdCommissionSetting(data, err) {
    return request._get('/shop/setting/jdSetting/getJdCommissionSetting', data, err);
  },

  // 申请审核列表
  jdMerchantPage(data, err) {
    return request._get('/shop/jdMerchant/jdMerchantPage', data, err);
  },
  // 审核
  jdMerchantExamine(data, err) {
    return request._postBody('/shop/jdMerchant/jdMerchantExamine', data, err);
  },
  // 后台给代理创建商户
  shopSaveUserJdMerchant(data, err) {
    return request._postBody('/shop/jdMerchant/shopSaveUserJdMerchant', data, err);
  },

  jdMerchantPage2(data, err) {
    return request._get('/shop/yxshopJdServiceProviderAuditRecord/jdMerchantPage', data, err);
  },

  importMerchant(data, err) {
    return request._postBody('/shop/jdMerchant/importMerchant', data, err);
  },

  categoryPageList(data, err) {
    return request._get('/shop/jdCategory/categoryPageList', data, err);
  },
  saveJdCategory(data, err) {
    return request._postBody('/shop/jdCategory/saveJdCategory', data, err);
  },
  deleteJdCategory(data, err) {
    return request._postBody('/shop/jdCategory/deleteJdCategory', data, err);
  },
  contentPage(data, err) {
    return request._get('/shop/jdCategoryContent/contentPage', data, err);
  },
  saveJdCategoryContent(data, err) {
    return request._postBody('/shop/jdCategoryContent/saveJdCategoryContent', data, err);
  },
  deleteJdCategoryContent(data, err) {
    return request._postBody('/shop/jdCategoryContent/deleteJdCategoryContent', data, err);
  },
  // 保存京东到家cookie
  saveJddjCookiesSetting(data, err) {
    return request._postBody('/shop/setting/jdSetting/saveJddjCookiesSetting', data, err);
  },

  syncJddjData(data, err) {
    return request._postBody('/shop/yxshopJdServiceProviderAuditRecord/syncJddjData', data, err);
  },
  JdMerchantocr(data, err) {
    return request._get('/shop/jdMerchant/ocr', data, err);
  },
  smsCode(data, err) {
    return request._get('/shop/yxshopJdServiceProviderAuditRecord/smsCode', data, err);
  },
  JddjLogin(data, err) {
    return request._get('/shop/yxshopJdServiceProviderAuditRecord/JddjLogin', data, err);
  },
  // 佣金配置设置
  saveJdMonthCommissionSetting(data, err) {
    return request._postBody('/shop/setting/jdSetting/saveJdMonthCommissionSetting', data, err);
  },

  // 获取佣金配置
  getJdMonthCommissionSetting(data, err) {
    return request._get('/shop/setting/jdSetting/getJdMonthCommissionSetting', data, err);
  },
  //导入订单信息
  importMerchantOrder(data, err) {
    return request._postBody('/shop/jdMerchant/importMerchantOrder', data, err);
  },
  // 获取商家月结金额
  getMonthMerchantMoney(data, err) {
    return request._get('/shop/jdMerchant/getMonthMerchantMoney', data, err);
  },
  //发放月结金额
  payMonthMerchantMoney(data, err) {
    return request._postBody('/shop/jdMerchant/payMonthMerchantMoney', data, err);
  },
}

export default jingdongApi;



// WEBPACK FOOTER //
// ./src/api/plus/jingdong.js